import { ApplicationState } from "../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import {
  addStudents,
  assignStudentsToTeacher,
  clearAddStudentsError,
  hideUploadStudentsRosterModal,
  openFileUploadErrorModal,
} from "../../../../store/onboarding/actions";
import { connect } from "react-redux";
import UploadStudentsRosterModal from "../../../../components/common/onboarding/second-step/upload-students/UploadStudentsRosterModal";
import { Student } from "../../../../store/onboarding/types";
import { UserAssignmentRole } from "../../../../store/auth/types";

type PropsFromState = {
  originalFileName: string;
  columnsNames: Array<string>;
  rawData: Array<any>;
  show: boolean;
  isLoading: boolean;
  fileInputKey?: number;
  error?: any;
  isStudentRosterUploaded?: boolean;
  newStudents?: number[],
  currentRole?: UserAssignmentRole;
  isFromStudentRoster?: boolean;
};

type DispatchProps = {
  onHide: () => any;
  addStudents: (students: Array<Student>) => any;
  clearAddStudentsError?: () =>  any;
  openFileUploadErrorModal?: (message: any) => void;
};

const mapStateToProps = ({ onboarding, auth }: ApplicationState): PropsFromState => {
  const loadableFile = onboarding.loadableFile;
  return {
    originalFileName: loadableFile ? loadableFile.originalFileName! : "",
    rawData: loadableFile ? loadableFile.rawData : [],
    columnsNames: loadableFile ? loadableFile.columnsNames : [],
    isFromStudentRoster: loadableFile ? loadableFile.isFromStudentRoster : false,
    fileInputKey: loadableFile ? loadableFile.fileInputKey : undefined,
    show: onboarding.modalsState.uploadStudentsRosterModal,
    isLoading: onboarding.isLoading.addStudents,
    error: onboarding.errors.addStudents,
    isStudentRosterUploaded: onboarding.isStudentRosterUploaded,
    newStudents: onboarding.newStudents,
    currentRole: auth.userInfo?.profile.current_role!,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      assignStudentsToTeacher: assignStudentsToTeacher,
      onHide: hideUploadStudentsRosterModal,
      addStudents: addStudents,
      clearAddStudentsError: clearAddStudentsError,
      openFileUploadErrorModal: openFileUploadErrorModal
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadStudentsRosterModal);
